import React, { Component, Fragment } from 'react';
import Translate from 'react-translate-component';

export default class FieldsGroup extends Component {
    render() {
        const { translate, children, className = 'document-field-header', translatePrefix } = this.props;
        return (
            <Fragment>
                <Translate
                    component="h3"
                    content={translatePrefix ? `xml.${translatePrefix}.title.${translate}` : `xml.title.${translate}`}
                    className={className} />
                { children }
            </Fragment>
        );
    }
}
